import { StatusCode } from '../api/enumerations';
import { LoginProps } from '../api/login/types';
import { Constants as AuthConstants } from '../constants/auth';
import { setLocalStorageToken, setMfaPendingSession } from './localStorage';
import { MfaMode, MfaPendingSession, resolveMfaMode } from './mfa';

export type SessionRoute = '/mfa' | '/home';

/** The pending session of a login that needs a second factor. */
export const toMfaPendingSession = (
  token: string,
  mode: MfaMode,
  response: LoginProps
): MfaPendingSession => ({ token, mode, exp: response.claims?.exp });

/**
 * Turns a login response into a session and says where to go next. An
 * MFA-pending token is kept out of the session storage on purpose: the API
 * only accepts it on the MFA endpoints, and the MFA screen is the single
 * place allowed to use it (REAL-3266). Throws when the response is not a
 * usable login.
 */
export const openSessionFromLogin = (response: LoginProps): SessionRoute => {
  if (response.detail.description) {
    throw new Error(response.detail.description);
  }
  if (
    response.detail.status_code !== StatusCode.OK ||
    !response.access_token ||
    !response.user
  ) {
    throw new Error(AuthConstants.genericError);
  }

  const mfaMode = resolveMfaMode(response);
  if (mfaMode) {
    setMfaPendingSession(
      toMfaPendingSession(response.access_token, mfaMode, response)
    );
    return '/mfa';
  }

  setLocalStorageToken(response.access_token, response.claims);
  return '/home';
};
